import { Controller } from "@hotwired/stimulus";
// import * as ActiveStorage from "@rails/activestorage";
// ActiveStorage.start();

// Connects to data-controller="media-preview"
// export default class extends Controller {
//   static targets = [
//     "input",
//     "headerBlackContainer",
//     "headerWhiteContainer",
//     "navbarContainer",
//     "frontPreviewContainer",
//     "backPreviewContainer",
//     "noMediaContainer",
//     "imageFrontPreview",
//     "imageBackPreview",
//     "videoFrontPreview",
//     "videoBackPreview",
//     "submitButton",
//     "emptyElement",
//     "buttonContainer",
//     "dealForm",
//   ];

//   connect() {
//     this.reset();
//   }

//   // Trigger the hidden file input based on button click
//   triggerUpload(event) {
//     const index = event.currentTarget.dataset.index;
//     this.inputTargets[index].click();
//   }

//   // Handle the file change and show preview
//   handleFile(event) {
//     const file = event.target.files[0];
//     if (!file) return;

//     const url = URL.createObjectURL(file);

//     if (file.type.startsWith("image/")) {
//       this.imageFrontPreviewTarget.src = url;
//       this.imageBackPreviewTarget.src = url;
//       this.imageFrontPreviewTarget.classList.remove("hidden");
//       this.videoFrontPreviewTarget.classList.add("hidden");
//       this.videoBackPreviewTarget.classList.add("hidden");
//     } else if (file.type.startsWith("video/")) {
//       this.videoFrontPreviewTarget.src = url;
//       this.videoBackPreviewTarget.src = url;
//       this.videoFrontPreviewTarget.classList.remove("hidden");
//       this.videoBackPreviewTarget.classList.remove("hidden");
//       this.imageFrontPreviewTarget.classList.add("hidden");
//     }
//     // Toggle UI elements
//     this.emptyElementTarget.remove();
//     this.frontPreviewContainerTarget.classList.remove("hidden");
//     this.buttonContainerTarget.classList.add("hidden");
//     this.submitButtonTarget.classList.remove("hidden");
//     this.noMediaContainerTarget.classList.add("hidden");
//   }

//   // Reset media (Cross button logic)
//   reset() {
//     const html = `<div data-media-preview-target="emptyElement"></div>`;
//     this.navbarContainerTarget.insertAdjacentHTML("beforeend", html);
//     this.inputTargets.forEach((input) => (input.value = "")); // Clear inputs
//     this.frontPreviewContainerTarget.classList.add("hidden");
//     this.buttonContainerTarget.classList.remove("hidden");
//     this.submitButtonTarget.classList.add("hidden");
//     this.noMediaContainerTarget.classList.remove("hidden");

//     // Cleanup memory
//     this.imageFrontPreviewTarget.src = "";
//     this.imageBackPreviewTarget.src = "";
//     this.videoFrontPreviewTarget.src = "";
//     this.videoBackPreviewTarget.src = "";
//   }

//   goforward() {
//     this.headerBlackContainerTarget.classList.add("hidden");
//     this.frontPreviewContainerTarget.classList.add("hidden");
//     this.headerWhiteContainerTarget.classList.remove("hidden");
//     this.backPreviewContainerTarget.classList.remove("hidden");
//     this.dealFormTarget.classList.remove("hidden");
//   }

//   gobackward() {
//     this.headerWhiteContainerTarget.classList.add("hidden");
//     this.backPreviewContainerTarget.classList.add("hidden");
//     this.dealFormTarget.classList.add("hidden");
//     this.headerBlackContainerTarget.classList.remove("hidden");
//     this.frontPreviewContainerTarget.classList.remove("hidden");
//   }
// }

export default class extends Controller {
  static targets = [
    "imageInput",
    "imagePreviewContainer",
    "videoInput",
    "videoPreview",
  ];

  previewImages() {
    const files = Array.from(this.imageInputTarget.files);

    // Clear existing dynamic previews (optional - remove if you want to keep showing existing attachments)
    // Note: This logic only clears the preview UI, it doesn't delete from the server.
    this.imagePreviewContainerTarget.innerHTML = "";

    files.forEach((file) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const img = document.createElement("img");
        img.src = e.target.result;
        img.classList.add(
          "w-full",
          "h-24",
          "object-cover",
          "rounded-lg",
          "border",
        );
        this.imagePreviewContainerTarget.appendChild(img);
      };
      reader.readAsDataURL(file);
    });
  }

  previewVideo() {
    const file = this.videoInputTarget.files[0];
    if (file) {
      this.videoPreviewTarget.src = URL.createObjectURL(file);
      this.videoPreviewTarget.classList.remove("hidden");
      this.videoPreviewTarget.load();
    }
  }
}
